import React from 'react';
import { MonitorPlayIcon } from 'lucide-react';
export function WhatIsSection() {
  return <section className="bg-[#0a1628] py-16 md:py-24 px-4 border-b border-blue-900/30 relative overflow-hidden" data-id="element-247">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#4a9eff 1px, transparent 1px), linear-gradient(90deg, #4a9eff 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-248"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-249">
        <div className="flex justify-center mb-6" data-id="element-250">
          <div className="w-16 h-16 bg-blue-900/40 rounded-2xl flex items-center justify-center border border-blue-500/30 shadow-[0_0_20px_rgba(37,99,235,0.2)]" data-id="element-251">
            <MonitorPlayIcon className="w-8 h-8 text-blue-400" data-id="element-252" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white mb-10 uppercase leading-tight" data-id="element-253">
          ¿QUÉ ES SISTEMA COMPLETO DE <br className="hidden md:block" data-id="element-254" />
          <span className="text-blue-400" data-id="element-255">0 A INSTALADOR DE CÁMARAS?</span>
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed text-left" data-id="element-256">
          <p data-id="element-257">
            Es un programa digital paso a paso diseñado para ayudarte a aprender
            instalación de cámaras desde cero, incluso si hoy no tenés
            experiencia previa en el rubro.
          </p>

          <p data-id="element-258">
            Vas a entender cómo funciona todo el proceso, desde la elección de
            componentes hasta la instalación, configuración, diagnóstico de
            fallas y los primeros pasos para empezar a ofrecer este servicio.
          </p>

          <div className="bg-[#0d1b2a] p-6 md:p-8 rounded-xl shadow-lg border border-blue-900/30 relative overflow-hidden my-10" data-id="element-259">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-red-500 to-red-800" data-id="element-260"></div>
            <div className="space-y-3 pl-4" data-id="element-261">
              <p className="font-bold text-white flex items-center gap-2" data-id="element-262">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-263"></span>
                No es teoría desordenada.
              </p>
              <p className="font-bold text-white flex items-center gap-2" data-id="element-264">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-265"></span>
                No son tutoriales aislados.
              </p>
              <p className="font-bold text-white flex items-center gap-2" data-id="element-266">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-267"></span>
                No es contenido que te deja con más dudas que soluciones.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-900/0 via-blue-900/40 to-blue-900/0 p-6 rounded-xl border-y border-blue-500/20" data-id="element-268">
            <p className="text-2xl font-bold text-center text-blue-300" data-id="element-269">
              Es una ruta clara para aprender una habilidad práctica, útil y con
              salida real.
            </p>
          </div>
        </div>
      </div>
    </section>;
}